import * as React from 'react';
import { observer } from 'mobx-react';
import { SvgIcon, SvgProperties } from '../svg-icon';
import { classNames } from '../../../Shared/utils/classnames';
import { Text } from '../text';

import { tabs, tab, label, button, icon, active } from './tabs.less';

export interface ITabOption {
	label: string;
	value: number;
	acceptanceTestTargetId: string;
	icon?: SvgProperties;
	disableTranslation?: boolean;
}

@observer
export class Tabs extends React.Component<{
	selectedTab: number;
	onChange: (value: number) => void;
	options: ITabOption[];
	className?: string;
},{}> {
	render() {
		const { selectedTab, options, className = '' } = this.props;
		const tabStyle = { width: `${100/options.length}%` };

		return (
			<ul className={classNames(tabs, className)}>
				{options.map((option) => <Tab key={option.value} isActive={selectedTab === option.value} onSelect={this.onSelect} style={tabStyle} {...option} />)}
			</ul>
		);
	}

	onSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
		this.props.onChange(Number(event.currentTarget.value));
	}
}

export class Tab extends React.Component<{
	value: number;
	label: string;
	acceptanceTestTargetId: string;
	onSelect: (event: React.MouseEvent<HTMLButtonElement>) => void;
	isActive: boolean;
	style?: React.CSSProperties;
	icon?: SvgProperties;
	disableTranslation?: boolean;
},{}> {
	render() {
		const { label: tabLabel, value, onSelect, isActive, acceptanceTestTargetId, style, disableTranslation } = this.props;
		const svgIcon = this.props.icon as SvgProperties;

		const iconOnly = !tabLabel && icon;
		return (
			<li role="presentation" className={`${tab} ${isActive ? active : ''}`} style={style}>
				<button
					className={`${button} ${isActive ? 'brand-primary-border-bottom' : ''}`}
					type="button"
					value={value}
					onClick={onSelect}
					data-pp-at-target={acceptanceTestTargetId}
				>
					{svgIcon && (
						<SvgIcon
							svg={svgIcon}
							className={iconOnly ? icon : `${icon} hidden-xs`}
							role="presentation"
						/>
					)}
					{!iconOnly && (
						<span className={label}>
							{disableTranslation ? tabLabel : <Text>{tabLabel}</Text>}
						</span>
					)}
				</button>
			</li>
		);
	}
}
